import { BuilderContext } from '@ha/algolia';
import { GlobalState } from 'ha/types/store';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';

export const getFilterBuilderContext = (
  state: GlobalState,
  queryType:
    | 'listings'
    | 'priceFacet'
    | 'propertyTypeFacet'
    | 'propertySizeFacet',
): BuilderContext => {
  // add experiments and feature flags regarding algolia query here
  const { withDynamicMinimumPrice } = getFeatureFlags(state);

  return {
    withoutPrice: queryType === 'priceFacet',
    withoutPropertyType: queryType === 'propertyTypeFacet',
    withDynamicMinimumPrice: withDynamicMinimumPrice === 'on',
    withoutPropertySize: queryType === 'propertySizeFacet',
  };
};
